import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BankChargesModel } from './bankcharges.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActualSelected, Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { UntypedFormControl } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-bankcharges-form',
    templateUrl: './bankcharges-form.component.html',
    styleUrls: ['./bankcharges.component.css'],
    standalone: false
})

export class BankChargesFormComponent implements OnInit {
  @Input() bankCharges: BankChargesModel;
  @Output() onSave = new EventEmitter<any>();

  public saved: boolean = false;

  destinations_options = [
    { id: true, name: 'Banco' },
    { id: false, name: 'Póliza de crédito' },
  ]

  projects: MasterModel [] = [];
  expenseProjectTypes: MasterModel [] = [];

  constructor(
    public snackBar: MatSnackBar,
    private bankAccountService: BankAccountService,
    private polizaCreditoService: PolizaCreditoService,
    private masterService: MasterService,
    private cdr: ChangeDetectorRef,
    private activityService : ActivityService
  ) { }

  bankAccounts: BankAccountModel[] = [];
  polizaCredito: PolizaCredito[] = [];
  ready: boolean = false;

  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<string[]>;
  conceptList: string[] = [];
  isProjectEnable: boolean = false;

  ngOnInit() {
    this.ready = false;

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
          this.isProjectEnable = activity.isProject;
        });

    this.bankAccountService.getList().then(
      bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      }
    );

    this.polizaCreditoService.list().then(
      response => {
        this.polizaCredito = response.list;
        this.ready = true;
      }
    );

    this.setConcepts();
    this.conceptCtrl = new UntypedFormControl();
    this.filteredConcepts = this.conceptCtrl.valueChanges
      .pipe(
        map(concept => concept && typeof concept === 'string' ? concept : ''),
        map(name => this.filterConcepts(name))
      );

    if (Utils.IsNullOrEmpty(this.bankCharges.expenseAccount)) {
      this.bankCharges.expenseAccount = '6260000001';
    }

    this.masterService.getProjects().subscribe(data => {
      this.projects=data;
      this.cdr.detectChanges();
    })
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes=data;
      this.cdr.detectChanges();
    });
  }

  setConcepts() {
    this.conceptList.push('COMISIONES/LIQUIDACIÓN');
    this.conceptList.push('CUENTA/GASTOS');
    this.conceptList.push('DEVOLUCIÓN');
  }

  filterConcepts(val) {
    for (const concept of this.conceptList) {
      if (concept === val) {
        this.bankCharges.concept = concept;
      }
    }

    const normalizedValue = this.normalize(val);
    return val ? this.conceptList.filter(concept => this.normalize(concept).includes(normalizedValue)) : this.conceptList;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  save(): void {
    let noError = true;

    if (Utils.IsNullOrEmpty(this.bankCharges.concept)) {
      noError = false;
      this.displayInfo("El campo concepto no puede estar vacío.");
    } else if (Utils.IsNullOrEmptyNumber(this.bankCharges.amount)) {
      noError = false;
      this.displayInfo("El campo importe no puede estar vacío.");
    } else if (Utils.IsNullOrEmptyDate(this.bankCharges.date)) {
      noError = false;
      this.displayInfo("La campo fecha no puede estar vacía");
    } else if (!Utils.DateIsInFiscalYear(this.bankCharges.date)) {
      noError = false;
      this.displayInfo("La fecha y el año fiscal seleccionado, no son el mismo.");
    } else if (!this.isValidExpenseAccount(this.bankCharges.expenseAccount)) {
      noError = false;
      this.displayInfo("La cuenta contable no es válida");
    }

    if (this.bankCharges.destinationIsBankAccount === true && Utils.IsNullOrEmpty(this.bankCharges.bankAccountUid)) {
      noError = false;
      this.displayInfo("El campo cuentas bancarias no puede estar vacía. Si no tiene ninguna cuenta bancaria puede crearlos desde el el menú de Mi Cuenta");
    }

    if (this.bankCharges.destinationIsBankAccount === false && Utils.IsNullOrEmpty(this.bankCharges.polizaCreditoId)) {
      noError = false;
      this.displayInfo("El campo poliza de credito no puede estar vacía. ");
    }

    if (this.bankCharges.destinationIsBankAccount === true) {
      this.bankCharges.polizaCreditoId = "";
    }

    if (this.bankCharges.destinationIsBankAccount === false) {
      this.bankCharges.bankAccountUid = consts.EMPTY_GUID;
    }

    if (noError) {
      this.onSave.emit(this.bankCharges)
    }

  }

  isValidExpenseAccount(account: string): boolean {
    if (Utils.IsNullOrEmpty(account)) {
      return false;
    }

    const validAccount = consts.ACCOUNT_BANK_CHARGES;
    if (account.startsWith(validAccount)) {
      return true;
    }

    return false;
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }


  public trackByIndex(i: number) { return i; }

}
